import { CONVERSATION } from "../apiConstant";
import BaseApi from "../baseApi";

class ConversationApi extends BaseApi {
  connectPerson(param) {
    if (param?.personId) {
      return this.post(`${CONVERSATION}/connect-person`, param);
    }
    return Promise.resolve(null);
  }

  getList(param) {
    return this.post(`${CONVERSATION}/list`, param);
  }

  getListMessageSearch(param) {
    return this.post(`${CONVERSATION}/list-message-search`, param);
  }

  getListMissed(param) {
    return this.post(`${CONVERSATION}/list-missed`, param);
  }

  getListSeenTs(param) {
    return this.get(`${CONVERSATION}/lastSeenTs?conversationId=${param}`);
  }

  findGroup(param) {
    return this.post(`${CONVERSATION}/find-chat`, param);
  }

  createGroup(param) {
    return this.post(`${CONVERSATION}/add-chat`, param);
  }

  initSelfChatForAllUsers() {
    return this.post(`${CONVERSATION}/init-self-chat`);
  }

  createMailGroup(param) {
    return this.post(`${CONVERSATION}/add-mail`, param);
  }

  createEmptyConversation(param) {
    return this.post(`${CONVERSATION}/create-empty`, param);
  }

  changeStar(param) {
    return this.get(`${CONVERSATION}/starred?userConversationId=${param}`);
  }

  getMemberList(param) {
    return this.post(`${CONVERSATION}/member-list`, param);
  }

  changeUnread(param) {
    return this.post(`${CONVERSATION}/read`, param);
  }

  seenReaction(param) {
    return this.post(`${CONVERSATION}/seen-reaction`, param);
  }

  deleteGroup(param) {
    return this.delete(`${CONVERSATION}/${param}`);
  }

  disableGroup(param) {
    return this.post(`${CONVERSATION}/disable/${param}`);
  }

  enableGroup(param) {
    return this.post(`${CONVERSATION}/enable/${param}`);
  }

  uploadGroupAvatar(param) {
    return this.post(`${CONVERSATION}/group-avatar`, param);
  }

  getConversation(param) {
    return this.post(`${CONVERSATION}/${param}`);
  }

  addDraft(param) {
    return this.post(`${CONVERSATION}/draft`, param);
  }

  deleteDraft(param) {
    return this.post(`${CONVERSATION}/delete-draft`, param);
  }

  changeAlarm(param) {
    return this.post(`${CONVERSATION}/alarm`, param);
  }

  type(param) {
    return this.post(`${CONVERSATION}/typing`, param);
  }

  pinnedConversation(param) {
    return this.post(`${CONVERSATION}/pinned-conversation/${param}`);
  }

  getMemberIds(param) {
    return this.get(`${CONVERSATION}/member-id/${param}`);
  }

  getRepresentResource(param) {
    return this.get(`${CONVERSATION}/resource/represent/${param}`);
  }

  getResourceList(param) {
    return this.post(`${CONVERSATION}/resource/list`, param);
  }

  detailResource(param) {
    return this.post(`${CONVERSATION}/resource/detail`, param);
  }
}

export default ConversationApi;
